import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { invalidateFor } from "@/lib/cache-registry";

/** VIB-909: henter/oppretter reisetid-budsjettlinjen for et prosjekt (RPC). */
export function useEnsureReisetidLine() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (projectId: string): Promise<string> => {
      const { data, error } = await supabase.rpc("get_or_create_reisetid_line", {
        p_project_id: projectId,
      });
      if (error) throw error;
      return data as string;
    },
    onSettled: async (_d, _e, projectId) => {
      await invalidateFor(qc, "upsells", { projectId });
    },
  });
}
